import { render, staticRenderFns } from "./add-hospital-dialog.vue?vue&type=template&id=4ba482e2&"
import script from "./add-hospital-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-hospital-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-hospital-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports